export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-200 pt-14 pb-8">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <span className="text-xl font-heading font-bold text-background-50 mb-3 block">
              触手漫画
            </span>
            <p className="text-xs text-background-400 leading-relaxed">
              触手题材漫画免费在线阅读平台。海量触手漫画全集，下拉式畅快阅读，每日实时更新。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-3">
              快速导航
            </h4>
            <ul className="space-y-2">
              <li>
                <a href="#hero" className="text-xs text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  首页
                </a>
              </li>
              <li>
                <a href="#topics" className="text-xs text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  热门话题
                </a>
              </li>
              <li>
                <a href="#cards" className="text-xs text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  精选推荐
                </a>
              </li>
              <li>
                <a href="#ranking" className="text-xs text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  热度排行
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-3">
              常用链接
            </h4>
            <ul className="space-y-2">
              <li>
                <a href="#faq" className="text-xs text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  常见问答
                </a>
              </li>
              <li>
                <a href="#contact" className="text-xs text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  联系我们
                </a>
              </li>
              <li>
                <a href="#app" className="text-xs text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  App下载
                </a>
              </li>
              <li>
                <a href="#about" className="text-xs text-background-400 hover:text-background-100 transition-colors cursor-pointer">
                  关于我们
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-3">
              合作伙伴
            </h4>
            <p className="text-xs text-background-400 leading-relaxed">
              触手漫画网期待与优质漫画平台、创作者和内容伙伴携手合作，共同推动触手漫画的发展。
            </p>
          </div>
        </div>

        <div className="border-t border-background-700/50 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2024 触手漫画 chushoumanhua.com - 触手题材漫画免费在线阅读平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-500 hover:text-background-200 transition-colors cursor-pointer">
              隐私政策
            </a>
            <a href="#hero" className="text-xs text-background-500 hover:text-background-200 transition-colors cursor-pointer">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}